export * from './components/Component_ResourceManager/index.js';
//# sourceMappingURL=index.js.map